import { NotificationEnum } from "../constants/enums";
import type { NotificationModel } from "../types/models";

type NotificationCopy = {
  title: string;
  description: string;
  tone: "orange" | "blue" | "green" | "red" | "primary";
};

const formatVitalLabel = (vitalField?: unknown) => {
  if (typeof vitalField !== "string" || !vitalField) {
    return null;
  }
  return vitalField.replace(/_/g, " ");
};

export const getNotificationCopy = (
  notification: NotificationModel
): NotificationCopy => {
  switch (notification.action) {
    case NotificationEnum.CREATE_PLAN:
      return {
        title: "New Care Plan",
        description: "A new care plan has been created and needs your review.",
        tone: "orange",
      };
    case NotificationEnum.EDIT_PLAN:
      return {
        title: "Care Plan Updated",
        description: "A care plan has been updated.",
        tone: "blue",
      };
    case NotificationEnum.ACTIVATE_PLAN:
      return {
        title: "Care Plan Activated",
        description: "Your care plan has been activated.",
        tone: "green",
      };
    case NotificationEnum.REJECT_PLAN:
      return {
        title: "Care Plan Rejected",
        description: "A care plan has been rejected.",
        tone: "red",
      };
    case NotificationEnum.VITALS_WARNING: {
      const vitalLabel = formatVitalLabel(notification.data?.vital_field);
      return {
        title: "Vitals Need Attention",
        description: vitalLabel
          ? `Your ${vitalLabel} reading requires attention.`
          : "Your recent vital readings require attention.",
        tone: "orange",
      };
    }
    case NotificationEnum.MEDICATION_REMINDER:
      return {
        title: "Medication Reminder",
        description: "Remember to take your prescribed medications.",
        tone: "primary",
      };
    default:
      return {
        title: "Notification",
        description: "You have a new update.",
        tone: "primary",
      };
  }
};
